import useSubscriptionQueries, {
  useUserActiveModulesSubscriptions,
} from '@/hooks/subscription/useSubscriptionQueries';
import { clearRequestState } from '@/hooks/subscription/useSubscriptionRequestState';
import { selectUser } from '@/redux/auth/authSlice';
import { useAppSelector } from '@/redux/hooks';
import routes from '@/routes';
import toaster from '@/toaster';
import { Layout } from 'antd';
import { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import MyErrorBoundary from '../ErrorBoundray/ErrorBoundray';
import Seo from '../components/Seo';
import SuspenseLoader from '../components/SuspenseLoader';
import findItemByUrl from '../helpers/findItemByUrl';
import Header from './Header.layout';
import classes from './MainLayout.module.css';
import SidebarLayout from './Sidebar.layout';
import { useGenerateItems } from './menuItems';

const { Content } = Layout;

const MainLayout = () => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  const user = useAppSelector(selectUser);
  const { subscriptionStatus } = useSubscriptionQueries();
  const { userActiveModulesSubscriptions } = useUserActiveModulesSubscriptions();

  const items = useGenerateItems(t, user, userActiveModulesSubscriptions);

  const url = window.location.pathname;

  const activeMenuTab = findItemByUrl(url, items);

  useEffect(() => {
    if (!user) return;

    const mainLayoutRoutes = routes.find((route) => route.path === '/');
    const currentRoute = (mainLayoutRoutes?.children || []).find((route) => route.path === url);
    if (subscriptionStatus?.status === 'expired' || subscriptionStatus?.status === 'inactive') {
      const allowedRoutesForExpiredSubscription = [
        '/settings/upgrade',
        '/settings/upgrade/billing',
        '/settings/modules/inventory',
        '/employees/all',
        '/employees/add',
        '/employees/edit/:id',
        '/employees/roles',
        '/employees/roles/add',
        '/employees/roles/edit/:id',
        'pricing',
      ];

      if (!allowedRoutesForExpiredSubscription.includes(url)) {
        navigate('/settings/upgrade');
      }
    } else {
      clearRequestState();
    }

    if (currentRoute && currentRoute.permissionCB && !currentRoute.permissionCB(user)) {
      navigate(-1);
      toaster.error(t('noPermissionToAccess'));
    }
  }, [navigate, t, url, user, subscriptionStatus]);

  return (
    <>
      <Seo title={activeMenuTab?.label ? `${activeMenuTab.label}` : 'Orino'} />
      <Layout style={{ minHeight: '100vh' }}>
        <SidebarLayout items={items} />
        <Layout>
          <Header activeMenuTab={activeMenuTab} />
          <Content
            style={{
              backgroundColor: 'var(--bg-clr)',
            }}
          >
            <div className={classes.content}>
              <Suspense fallback={<SuspenseLoader />}>
                <MyErrorBoundary>
                  <Outlet />
                </MyErrorBoundary>
              </Suspense>
            </div>
          </Content>
          {/* <Footer style={{ height: '90px', backgroundColor: 'var(--bg-clr)' }}>
            <div style={{ textAlign: 'center' }}>NORT ©{new Date().getFullYear()}</div>
          </Footer> */}
        </Layout>
      </Layout>
    </>
  );
};

export default MainLayout;
